(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["compare-template-new"] && !Shopify.designMode) return;
  try {
    
  function setTranformX(element, value) { 
      element.css({
          '-moz-transform': 'translateX(' + value + 'px)',
          '-webkit-transform': 'translateX(' + value + 'px)',
          '-ms-transform': 'translateX(' + value + 'px)',
          '-o-transform': 'translateX(' + value + 'px)',
          'transform': 'translateX(' + value + 'px)'
      });
  }
   function updateProperties() {
         var productsNumber = $(".cd-products-columns .product").length;
         var productWidth = $(".cd-products-columns .product").eq(0).width();

        // this.tableHeight = this.table.height();
        // this.productWidth = this.products.eq(0).width();
        // this.topInfoHeight = this.featuresTopInfo.innerHeight() + 30;
         $(".cd-products-columns").css('width', productWidth * productsNumber + 'px');
    }
  var windowResize = false;
  function checkResize() {
     console.log(121212333)
     updateProperties();
     windowResize = false;
  }

  $(document).ready(function(){ 

    var filtering = false;
    var selectedproductsNumber = 0;
    var productsNumber = $(".cd-products-columns .product").length;
    var productWidth = $(".cd-products-columns .product").eq(0).width();
    var leftScrolling = false;

    //判断pc端或者手机端的函数方法
    var os = function() {
        var ua = navigator.userAgent,
            isWindowsPhone = /(?:Windows Phone)/.test(ua),
            isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
            isAndroid = /(?:Android)/.test(ua),
            isFireFox = /(?:Firefox)/.test(ua),
            isChrome = /(?:Chrome|CriOS)/.test(ua),
            isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)),
            isPhone = /(?:iPhone)/.test(ua) && !isTablet,
            isPc = !isPhone && !isAndroid && !isSymbian;
        return {
            isTablet: isTablet,
            isPhone: isPhone,
            isAndroid : isAndroid,
            isPc : isPc
        };
    }();


     console.log(windowResize)
     if (!windowResize) {
        windowResize = true;
        (!window.requestAnimationFrame) ? setTimeout(checkResize, 250): window.requestAnimationFrame(checkResize);
    }

    //detect window resize - reset .cd-products-comparison-table properties
    $(window).on('resize', function () {
        if (!windowResize) {
            windowResize = true;
            (!window.requestAnimationFrame) ? setTimeout(checkResize, 250): window.requestAnimationFrame(checkResize);
        }
    });
    const upadteFilterBtn = function () {
        //show/hide filter btn
        if (selectedproductsNumber >= 2) {
            filterActive = true;
            $("#products-comparison .filter").addClass('active');
        } else {
            filterActive = false;
            $("#products-comparison .filter").removeClass('active');
        }
    }

    const resetProductsVisibility =  function () {
        var self = this,
            containerOffsetLeft = $(".cd-products-columns").offset().left,
            selectedProducts = $(".cd-products-columns .product").filter('.selected'),
            numberProducts = selectedProducts.length,
            scrollLeft = $(".cd-products-wrapper").scrollLeft(),
            n = 0;

        $("#products-comparison").addClass('no-product-transition').removeClass('filtered');

        $(".cd-products-columns .product").each(function (index) {
            var product = $(this);
            if (product.hasClass('selected')) {
                n = n + 1;
                var leftTranslate = (-index + n - 1) * productWidth;
                setTranformX(product, leftTranslate);
            }
        });

        setTimeout(function () {
            $("#products-comparison").removeClass('no-product-transition filtering');
            setTranformX(selectedProducts, '0');
            selectedProducts.removeClass('selected').attr('style', '');
        }, 50);
    }

    const resetSelection = function () {
      $(".cd-products-columns").css('width', productWidth * productsNumber + 'px');
      $("#products-comparison").removeClass('no-product-transition');
      resetProductsVisibility();
    }

    const filterProducts = function () {
      var containerOffsetLeft = $(".cd-products-columns").offset().left,
          scrollLeft = $(".cd-products-wrapper").scrollLeft(),
          selectedProducts = $(".cd-products-columns .product").filter('.selected'),
          numberProducts = selectedProducts.length;
          productWidth = selectedProducts.eq(0).width();

      selectedProducts.each(function (index) {
           var product = $(this),
               leftTranslate = containerOffsetLeft + index * productWidth + scrollLeft - product.offset().left;
               setTranformX(product, leftTranslate);

           if (index == numberProducts - 1) {
                product.one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function () {
                    setTimeout(function () {
                        $("#products-comparison").addClass('no-product-transition');
                    }, 50);
                    setTimeout(function () {
                        $("#products-comparison").addClass('filtered');
                        $(".cd-products-wrapper").scrollLeft(0);
                         $(".cd-products-columns").css('width', productWidth * numberProducts + 'px');
                        selectedProducts.attr('style', '');
                        product.off('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend');
                        // self.updateNavigationVisibility(0);
                    }, 100);
                });
            }
      })
    }

    const showSelection = function () {
        $("#products-comparison").addClass('filtering');
        filterProducts();
    }

    const updateSlider = function (bool) {
        var scrollLeft = $(".cd-products-wrapper").scrollLeft();
        scrollLeft = (bool) ? scrollLeft + productWidth : scrollLeft - productWidth;

        if (scrollLeft < 0) scrollLeft = 0;
        if (scrollLeft > $(".cd-products-columns").outerWidth(true) - $(".cd-products-wrapper").width()) scrollLeft = $(".cd-products-columns").outerWidth(true) - $(".cd-products-wrapper").width();

        $(".cd-products-wrapper").animate({
            scrollLeft: scrollLeft
        }, 200);
    }

     $(".cd-products-wrapper").on('scroll', function () {
        if (!leftScrolling) {
            leftScrolling = true;
            (!window.requestAnimationFrame) ? setTimeout(function () {
                updateLeftScrolling();
            }, 250): window.requestAnimationFrame(function () {
                updateLeftScrolling();
            });
        }
    });

    const updateLeftScrolling = function () {

        var totalTableWidth = parseInt($(".cd-products-columns").eq(0).outerWidth(true)),
            tableViewport = parseInt($("#products-comparison").width()),
            scrollLeft = $(".cd-products-wrapper").scrollLeft();

        (scrollLeft > 0) ? $(".products-table").addClass('scrolling'): $(".products-table").removeClass('scrolling');

        if ($(".products-table").hasClass('top-fixed') && os.isPc ) {
            setTranformX($(".top-info"), '-' + scrollLeft);
            setTranformX($(".features .top-info"), '0');
        }

        leftScrolling = false;

        updateNavigationVisibility(scrollLeft);
    }

    const updateNavigationVisibility = function (scrollLeft) {
        (scrollLeft > 0) ? $(".cd-table-navigation").find('.prev').removeClass('inactive'): $(".cd-table-navigation").find('.prev').addClass('inactive');
        (scrollLeft < $(".cd-products-columns").outerWidth(true) - $(".cd-products-wrapper").width() && $(".cd-products-columns").outerWidth(true) > $(".cd-products-wrapper").width()) ? $(".cd-table-navigation").find('.next').removeClass('inactive'): $(".cd-table-navigation").find('.next').addClass('inactive');
    }



    class StickyNavigation {

    constructor() {
      this.currentId = null;
      this.currentTab = null;
      this.tabContainerHeight = 200;
      this.lockScroll = 0;
      let self = this;
      $(window).scroll(() => { this.onScroll(); });
    }

    onScroll(){
      this.checkProductTablesPosition();
    }
    checkProductTablesPosition(){
      // let offsetTop = $(".products-table").offset().top - 40;
      // console.log(offsetTop)
      // if($(window).scrollTop() > offsetTop) {
      //   $('.products-table').addClass('top-fixed');
      // }
      // else {
      //    $('.products-table').removeClass('top-fixed');
      // }

      var tableHeight = $(".products-table").height();
      var topInfoHeight = $(".products-table").children('.features').children('.top-info').innerHeight() + 30;
      var scrollTop = $(window).scrollTop();
      var offsetTop = $(".products-table").offset().top - 40,
            tableScrollLeft = $(".cd-products-wrapper").scrollLeft();

        if (offsetTop <= scrollTop && offsetTop + tableHeight - topInfoHeight >= scrollTop) {
            //fix products top-info && arrows navigation
            if (!$(".products-table").hasClass('top-fixed') ) {
                $(".products-table").addClass('top-fixed').removeClass('top-scrolling');
                if (os.isPc) {
                    $(".products-table").find('.top-info').css('top', '0');
                    // this.navigation.find('a').css('top', '80px');
                }
            }

        } else if (offsetTop <= scrollTop) {
            //product top-info && arrows navigation -  scroll with table
            $(".products-table").removeClass('top-fixed').addClass('top-scrolling');
            if (os.isPc) {
                $(".products-table").find('.top-info').css('top', (tableHeight - topInfoHeight) + 'px');
                // this.navigation.find('a').css('top', (tableHeight - topInfoHeight) + 'px');
            }
        } else {
            //product top-info && arrows navigation -  reset style
            $(".products-table").removeClass('top-fixed top-scrolling');
            $(".products-table").find('.top-info').attr('style', '');
            // this.navigation.find('a').attr('style', '');
        }

       updateLeftScrolling();
    }
  }

     new StickyNavigation();

    $(".cd-products-wrapper li.product .top-info").click(function(){
       var product = $(this).parents('.product');
        if (!filtering && product.hasClass('selected')) {
            product.removeClass('selected');
            selectedproductsNumber = selectedproductsNumber - 1;
            upadteFilterBtn();
        } else if (!self.filtering && !product.hasClass('selected')) {
            product.addClass('selected');
            selectedproductsNumber = selectedproductsNumber + 1;
            upadteFilterBtn();
        }
    })

    $(".reset").on('click', function (event) {
        event.preventDefault();
        if (filtering) {
            filtering = false;
            resetSelection();
        } else {
            $(".cd-products-wrapper li.product").removeClass('selected');
        }
        selectedproductsNumber = 0;
        upadteFilterBtn();
    });

     //filter products
    $(".filter").on('click', function (event) {
          event.preventDefault();
          if (filterActive) {
              filtering = true;
              showSelection();
              filterActive = false;
              $(".filter").removeClass('active');
          }
      });

    $(".cd-table-navigation").on('click','a',function (event) {
          event.preventDefault();
          updateSlider($(event.target).hasClass('next'));
      });
  })

  } catch(e) { console.error(e); }
})();
})();
